import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QuotaState } from './quota.state';

export const selectQuotaState = createFeatureSelector<QuotaState>('quota');

export const selectQuotaSummary = createSelector(
  selectQuotaState,
  (state) => state.summary
);

export const selectQuotaLoading = createSelector(
  selectQuotaState,
  (state) => state.loading
);

export const selectQuotaLoaded = createSelector(
  selectQuotaState,
  (state) => state.loaded
);

export const selectQuotaError = createSelector(
  selectQuotaState,
  (state) => state.error
);
